module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-26.1a93494a.jpg";